import { FileInput } from '@blueprintjs/core'

const ACCEPTED_FILE_TYPES = '.sav,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

const FileUploadInput = ({ 
  fileInputText, 
  loading, 
  onFileSelect,
  disabled = false 
}) => {
  return (
    <FileInput
      inputProps={{
        accept: ACCEPTED_FILE_TYPES,
        multiple: false,
      }}
      large
      text={fileInputText}
      buttonText={loading !== 'loading' ? 'Browse' : 'Uploading...'}
      disabled={disabled || ['loading', 'success'].includes(loading)}
      onInputChange={ev => {
        const file = ev.target.files[0]
        if (file && onFileSelect) {
          onFileSelect(file)
        }
        ev.target.value = ''
      }}
    />
  )
}

export default FileUploadInput